Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "CreateGroupModal900371746",
  {"root":"CreateGroupModal900371746--root","title":"CreateGroupModal900371746--title","control":"CreateGroupModal900371746--control","label":"CreateGroupModal900371746--label","buttons":"CreateGroupModal900371746--buttons","cancelButton":"CreateGroupModal900371746--cancelButton"},
  "",
  8,
  "CreateGroupModal900371746"
);

